import React from 'react'
import WebcamCapture from './Webcam'
const UploadStage = ({ handleImageUpload, children }) => {
  const handleImageDrop = data => {
    handleImageUpload(data)
  }

  return <div className={`ugc-upload`}>{children}</div>
}

export default UploadStage
